module.exports = __webpack_public_path__ + "img/love.0984040e.svg";